import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Box, Stack, Typography } from "@mui/material";
import Button from "../components/MUI/Button";
import FloatingItem from "./FloatingItem";
import TextBox from "../components/MUI/TextBox";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "../components/MUI/Checkbox";
import RadioButton from "../components/MUI/RadioButton";
import Switch from "../components/MUI/Switch";
import Slider from "../components/MUI/Slider";

import SuggestionClip from "../components/MUI/SuggestionClip";
import FilterClip from "../components/MUI/FilterClip";
import AssistiveClip from "../components/MUI/AssistiveClip";
import InputClip from "../components/MUI/InputClip";
import DatePicker from "../components/MUI/DatePicker";
import TimePicker from "../components/MUI/TimePicker";
import Menu from "../components/MUI/Menu";
import BasicDialog from "../components/MUI/BasicDialog";
import ListDialog from "../components/MUI/ListDialog";
import Divider from "../components/MUI/Divider";
import InsetVerticalDivider from "../components/MUI/InsetVerticalDivider";
import MiddleInsetVerticalDivider from "../components/MUI/MiddleInsetVerticalDivider";
import FullWidthHorizontalDivider from "../components/MUI/FullWidthHorizontalDivider";
import InsetHorizontalDivider from "../components/MUI/InsetHorizontalDivider";
import MiddleInsetHorizontalDivider from "../components/MUI/MiddleInsetHorizontalDivider";
import SearchBar from "../components/MUI/SearchBar";
import SearchViewModal from "../components/MUI/SearchViewModal";
import SegmentedButton from "../components/MUI/SegmentedButton";
import TabSingleUnit from "../components/MUI/TabSingleUnit";
import Avatar from "../components/MUI/Avatar";
import Snackbar from "../components/MUI/Snackbar";
import LinearProgressIndicator from "../components/MUI/LinearProgressIndicator";
import ProgressBarWidget from "../components/MUI/ProgressBarWidget";
import NavigationDrawer from "../components/MUI/NavigationDrawer";
import BottomNavigation from "../components/MUI/BottomNavigation";
import TopAppBar from "../components/MUI/TopAppBar";
import SmallFAB from "../components/MUI/SmallFAB";
import FABs from "../components/MUI/FABs";
import LargeFAB from "../components/MUI/LargeFAB";
import ExpandedFAB from "../components/MUI/ExpandedFAB";
import PlainTooltip from "../components/MUI/PlainTooltip";
import RichTooltip from "../components/MUI/RichTooltip";
import List from "../components/MUI/List";
import ListItem from "../components/MUI/ListItem";
import Thumbnail from "../components/MUI/Thumbnail";
import Monogram from "../components/MUI/Monogram";
import Card from "../components/MUI/Card";
import BuildingBlocksMenuListItem from "../components/MUI/BuildingBlocksMenuListItem";
import BuildingBlocksMenuListItem2Density from "../components/MUI/BuildingBlocksMenuListItem2Density";
import BuildingBlocksMenuListItem4Density from "../components/MUI/BuildingBlocksMenuListItem4Density";
import Icon from "../components/MUI/Icon";

import IconButtonToggleable from "../components/MUI/IconButtonToggleable";
import BadgeComp from "../components/MUI/Badge";
import NavigationDrawerSectionHeader from "../components/MUI/NavigationDrawerSectionHeader";
import NavigationDrawerHeadline from "../components/MUI/NavigationDrawerHeadline";
import NavigationRailSegment from "../components/MUI/NavigationRailSegment";
import NavigationDrawerItem from "../components/MUI/NavigationDrawerItem";
import UserImages from "../components/MUI/UserImages";
import ButtonSegment from "../components/MUI/ButtonSegment";

import Tag from "../components/Tag";

import OppTable from "../components/OppTable";
import QuickActionWidget from "../components/QuickActionWidget";
import AllOppCard from "../components/AllOppCard";
import DeploymentRoleProgress from "../components/dprogress";

import Dropdown from "../components/MUI/Dropdown";
import FileUpload from "../components/MUI/FileUpload";

import { Steper } from "../components/MUI/Step";
import ExpandedRadioButton from "../components/Custome/ExpandedRadioButton";
import FileUploaded from "../components/Custome/FileUploaded";
import Loader from "../components/Custome/Loader";
import CardTamplate from "../components/Custome/CardTamplate";
import EmploymentHistoryCard from "../components/Custome/EmploymentHistoryCard";
import DeploymentRoleCategoryCard from "../components/Custome/DeploymentRoleCategoryCard";
import PastProjectCard from "../components/Custome/PastProjectCard";
import Alert from "../components/Custome/Alert";

const renderNode = (node, customProps = {}) => {
  if (!node) return null;
  const {
    style,
    sx,
    label,
    id,
    type,
    name,
    children,
    icon,
    imageUrl,
    Text, // extract Text separately
    ...restProps
  } = node || {};
  const sxProp = sx || style || {};
  const renderSvgIcon = () => {
    if (!icon) return null;
    return (
      <Icon sx={{ verticalAlign: "middle", bgcolor: "transparent" }}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          dangerouslySetInnerHTML={{ __html: icon }}
        />
      </Icon>
    );
  };
  switch (type) {
    case "frame":
      return (
        <Box
          key={id}
          sx={{
            ...sxProp,
            ...(node.style?.flexDirection?.md === "row" &&
              node.children?.length > 3 && {
                flexWrap: {
                  xs: "nowrap",
                  sm: "nowrap",
                  md: "wrap",
                },
              }),
          }}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        >
          {children && children.map((child) => renderNode(child, customProps))}
        </Box>
      );
    case "Text":
      return (
        <Typography
          key={id}
          sx={{ ...sxProp }}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        >
          {label}
        </Typography>
      );

    case "Button": {
      const action =
        customProps.bindingFields &&
        customProps.bindingFields[node.name || node.id || node.label];
      const handleClick = async (e) => {
        if (action && action.apiUrl && action.method) {
          try {
            let payload = {};
            if (action.data) {
              Object.entries(action.data).forEach(([key, val]) => {
                payload[key] = customProps.state[val];
              });
            }
            const fetchOptions = {
              method: action.method,
              headers: { "Content-Type": "application/json" },
            };
            if (action.method !== "GET") {
              fetchOptions.body = JSON.stringify(payload);
            }
            const response = await fetch(action.apiUrl, fetchOptions);
            let result;
            try {
              result = await response.json();
            } catch (jsonErr) {
              result = await response.text();
            }
            if (action.showAlert) {
              window.alert("API response: " + JSON.stringify(result));
            }
          } catch (err) {
            window.alert("API error: " + err.message);
          }
        }
        // Floating event logic (use global handler)
        if (
          node.event &&
          node.data 
        ) {
          if (customProps.handleShowFloating) {
            customProps.handleShowFloating(node.event, node.data);
          }
        }
        if (
          customProps.handlers &&
          node.onClick &&
          customProps.handlers[node.onClick]
        ) {
          customProps.handlers[node.onClick](e);
        }
      };
      return (
        <Button
          key={id}
          variant="contained"
          style={{ ...node.style, flexDirection: "row" }}
          onClick={handleClick}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        >
          {icon && renderSvgIcon()}
          <Typography sx={Text?.style || {}}>{Text?.label}</Typography>
        </Button>
      );
    }
    case "Text Field":
      const validationRules = Object.keys(node)
        .filter(
          (k) =>
            /^v\d+$/.test(k) && typeof node[k] === "object" && node[k] !== null,
        )
        .map((k) => node[k]);

      const fieldDef =
        customProps.bindingFields &&
        customProps.bindingFields[node.name || node.id || node.label];
      const valueKey = fieldDef?.value;
      const value = valueKey ? customProps.state?.[valueKey] : undefined;
      const onChange = fieldDef?.onChange
        ? customProps.handlers?.[fieldDef.onChange]
        : undefined;
      return (
        <TextBox
          key={id}
          label={Text?.label}
          textStyle={Text?.style}
          variant="outlined"
          style={node.style || {}}
          validationRules={validationRules}
          value={value}
          onChange={onChange}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        />
      );
    case "Card Action Bar":
      return node?.Icon ? (
        <Icon key={id} sx={sxProp} {...restProps}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            dangerouslySetInnerHTML={{ __html: node?.Icon?.icon }}
          />
        </Icon>
      ) : (
        <Icon key={id} sx={sxProp} {...restProps} />
      );
    case "Checkbox":
      return (
        <Checkbox
          key={id}
          sx={sxProp}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        />
      );
    case "Radio Button":
      return (
        <RadioButton
          key={id}
          sx={sxProp}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        />
      );
    case "Switch":
      return (
        <Switch
          key={id}
          style={node.style || {}}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        />
      );
    case "Slider":
      return (
        <Slider
          key={id}
          sx={sxProp}
          {...Object.fromEntries(
            Object.entries(restProps).filter(([k]) => k !== "Text"),
          )}
        />
      );
    case "Suggestion Chip":
      return (
        <SuggestionClip
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Filter Chip":
      return (
        <FilterClip
          key={id}
          icon={
            icon ? (
              <span
                style={{ display: "flex", alignItems: "center" }}
                dangerouslySetInnerHTML={{ __html: icon }}
              />
            ) : undefined
          }
          label={node.Text.label}
          textStyle={node.Text.style}
          style={sxProp}
          {...restProps}
        />
      );

    case "Assistive Chip":
      return (
        <AssistiveClip
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Dropdown":
      return (
        <Dropdown
          key={id}
          style={node.style || {}}
          textStyle={node?.Text?.style || {}}
          label={node?.Text?.label || "Select"}
          options={node?.options || ["Option 1", "Option 2"]}
          value={node.value}
          onChange={node.onChange}
          {...restProps}
        />
      );

      // case "Step":
      const steps = [
        "Biography",

        "Education",

        "Employment History",

        "Deployment Roles",
        "Project History",
        "Software, Certifications, & Training",
      ];
      return (
        <Steper
          key={id}
          style={node?.style}
          label={node?.Text?.label}
          steps={steps}
          icon={
            icon ? (
              <span
                style={{ display: "flex", alignItems: "center" }}
                dangerouslySetInnerHTML={{ __html: icon }}
              />
            ) : undefined
          }
          textStyle={node?.Text?.style}
          {...restProps}
        />
      );

    case "Filter Dropdown":
      return (
        <Box
          key={id}
          sx={{
            ...node.style,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography fontWeight={500}>Status:</Typography>
          <Typography style={node.Text.style}>{node.Text.label}</Typography>
        </Box>
      );
    case "Input Chip":
      return (
        <InputClip
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Card":
      return (
        <Card key={id} sx={sxProp} {...restProps}>
          {children}
        </Card>
      );
    case "Plain Search":
      return (
        <Box
          key={id}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "2px solid #BDBDBD",
            borderRadius: "8px",
            background: "#fff",
            height: 48,
            px: 2,
            width: "100%",
            maxWidth: 400,
            ...node?.style,
          }}
          {...restProps}
        >
          <SearchIcon sx={{ color: "#757575", mr: 1, p: 0 }} />
          <InputBase
            placeholder={node?.Text?.label || "Search..."}
            sx={{
              flex: 1,
              fontSize: 18,
              color: "#333",
              ...node?.Text?.style,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </Box>
      );
    case "Tab Single Unit/Primary/Icon and label":
      return (
        <TabSingleUnit
          key={id}
          variant="primary-icon-and-label"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          icon={
            icon ? (
              <span dangerouslySetInnerHTML={{ __html: icon }} />
            ) : undefined
          }
          sx={sxProp}
          {...restProps}
        />
      );

    case "Tab Single Unit/Primary/Icon only":
      return (
        <TabSingleUnit
          key={id}
          variant="primary-icon-only"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Tab Single Unit/Primary/Label only":
      return (
        <TabSingleUnit
          key={id}
          variant="primary-label-only"
          label={node.Text.label}
          textStyle={node.Text.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Tab Single Unit/Secondary/Label only":
      return (
        <TabSingleUnit
          key={id}
          variant="secondary-label-only"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Tab Single Unit/Secondary/Icon and label":
      return (
        <TabSingleUnit
          key={id}
          variant="secondary-icon-and-label"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Date Picker":
      return (
        <DatePicker
          key={id}
          variant="date"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Time Picker":
      return (
        <TimePicker
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Menu":
      return <Menu key={id} buttonText={label} sx={sxProp} {...restProps} />;
    case "Building Blocks/Menu List Item":
      return <BuildingBlocksMenuListItem key={id} sx={sxProp} {...restProps} />;
    case "Building Blocks/Menu List Item: -2 density":
      return (
        <BuildingBlocksMenuListItem2Density
          key={id}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Building Blocks/Menu List Item: -4 density":
      return (
        <BuildingBlocksMenuListItem4Density
          key={id}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Status Progress Bar":
      return <LinearProgressIndicator key={id} sx={sxProp} {...restProps} />;
    case "Basic Dialog":
      return <BasicDialog key={id} title={label} sx={sxProp} {...restProps} />;
    case "List Dialog":
    case "Scrollable List Dialog":
      return <ListDialog key={id} title={label} sx={sxProp} {...restProps} />;
    case "List Item":
      return <ListItem key={id} sx={sxProp} {...restProps} />;
    case "Avatar":
      return <Avatar key={id} alt={label} sx={sxProp} {...restProps} />;
    case "Image/Thumbnail":
      return <Thumbnail key={id} src={imageUrl} sx={sxProp} {...restProps} />;
    case "Monogram":
      return <Monogram key={id} sx={sxProp} {...restProps} />;
    case "List":
      return <List key={id} sx={sxProp} {...restProps} />;
    case "Tooltip":
      return <PlainTooltip key={id} title={label} sx={sxProp} {...restProps} />;
    case "Plain Tooltip":
      return <PlainTooltip key={id} title={label} sx={sxProp} {...restProps} />;
    case "Rich Tooltip":
      return <RichTooltip key={id} title={label} sx={sxProp} {...restProps} />;
    case "Snackbar":
      return <Snackbar key={id} message={label} sx={sxProp} {...restProps} />;
    case "Progress Indicator":
    case "Linear Progress Indicator":
      return <LinearProgressIndicator key={id} sx={sxProp} {...restProps} />;
    case "Progress Bar Widget":
      return <ProgressBarWidget key={id} sx={sxProp} {...restProps} />;
    case "Navigation Drawer":
      return <NavigationDrawer key={id} sx={sxProp} {...restProps} />;
    case "Bottom Navigation":
      return <BottomNavigation key={id} sx={sxProp} {...restProps} />;
    case "Top App Bar":
      return <TopAppBar key={id} sx={sxProp} {...restProps} />;
    case "Small FAB":
      return <SmallFAB key={id} sx={sxProp} {...restProps} />;
    case "FAB":
      return <FABs key={id} sx={sxProp} {...restProps} />;
    case "Large FAB":
      return <LargeFAB key={id} sx={sxProp} {...restProps} />;
    case "Extended FAB":
      return <ExpandedFAB key={id} sx={sxProp} {...restProps} />;
    case "Search Bar":
      return <SearchBar key={id} sx={sxProp} {...restProps} />;
    case "Search View Modal":
      return <SearchViewModal key={id} sx={sxProp} {...restProps} />;
    case "Segmented Button":
      return (
        <SegmentedButton
          key={id}
          options={[label]}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Icon":
      return icon ? (
        <Icon key={id} style={sxProp} {...restProps}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            dangerouslySetInnerHTML={{ __html: icon }}
          />
        </Icon>
      ) : (
        <Icon key={id} style={sxProp} {...restProps} />
      );
    case "Icon Button":
      return icon ? (
        icon && (
          <Box sx={{ ...node.style }}>
            <Icon>
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",

                  justifyContent: "center",
                }}
                dangerouslySetInnerHTML={{ __html: icon }}
              />
            </Icon>
          </Box>
        )
      ) : (
        <Icon key={id} sx={sxProp} {...restProps} />
      );
    case "Icon Button Toggleable":
      return (
        <IconButtonToggleable
          key={id}
          sx={sxProp}
          icon={
            icon ? (
              <span dangerouslySetInnerHTML={{ __html: icon }} />
            ) : undefined
          }
          {...restProps}
        />
      );
    case "Badge":
      return (
        <BadgeComp
          key={id}
          badgeContent={node.badgeContent || 1}
          color="primary"
          sx={sxProp}
          {...restProps}
        />
      );
    case "Vertical Divider":
      return <Divider key={id} sx={sxProp} {...restProps} />;
    case "Inset Vertical Divider":
      return <InsetVerticalDivider key={id} sx={sxProp} {...restProps} />;
    case "Middle Inset Vertical Divider":
      return <MiddleInsetVerticalDivider key={id} sx={sxProp} {...restProps} />;
    case "Full-Width Horizontal Divider":
      return <FullWidthHorizontalDivider key={id} sx={sxProp} {...restProps} />;
    case "Inset Horizontal Divider":
      return <InsetHorizontalDivider key={id} sx={sxProp} {...restProps} />;
    case "Middle Inset Horizontal Divider":
      return (
        <MiddleInsetHorizontalDivider key={id} sx={sxProp} {...restProps} />
      );
    case "Navigation Drawer Section Header":
      return (
        <NavigationDrawerSectionHeader
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Navigation Drawer Headline":
      return (
        <NavigationDrawerHeadline
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Navigation Rail Segment":
      return (
        <NavigationRailSegment key={id} sx={sxProp} {...restProps}>
          {children}
        </NavigationRailSegment>
      );
    case "Navigation Drawer Item":
      return (
        <NavigationDrawerItem
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "User images/User Images":
      return (
        <UserImages
          key={id}
          images={node.images || []}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Building Blocks/button segment (middle)":
      return (
        <ButtonSegment
          key={id}
          position="middle"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Building Blocks/button segment (start)":
      return (
        <ButtonSegment
          key={id}
          position="start"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    case "Building Blocks/button segment (end)":
      return (
        <ButtonSegment
          key={id}
          position="end"
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          sx={sxProp}
          {...restProps}
        />
      );
    // Custom/Custome components
    case "Quick Action Widget":
      return (
        <QuickActionWidget
          key={id}
          label={node?.Text?.label}
          textStyle={node?.Text?.style}
          style={node?.style}
          icon={
            icon ? (
              <span dangerouslySetInnerHTML={{ __html: icon }} />
            ) : undefined
          }
          imageUrl={imageUrl}
          {...restProps}
        />
      );

    case "Tag":
      return (
        <Tag
          key={id}
          label={node?.Text?.label || "label"}
          icon={
            icon ? (
              <span
                style={{ margin: "auto" }}
                dangerouslySetInnerHTML={{ __html: icon }}
              />
            ) : undefined
          }
          textStyle={node?.Text?.style}
          style={node?.style}
        />
      );

    case "Status Progress Bar":
      return (
        <LinearProgressIndicator key={id} sx={{ color: "green" }} value={75} />
      );
    case "Dialog":
    case "Card Header":
    case "Project Header":
    case "Project Content Block":
      return (
        <Card key={id} sx={sxProp}>
          {children}
        </Card>
      );

    case "All Opportunity Card":
      return <AllOppCard key={id} style={style} />;
    case "Deployment Role Progress":
      return <DeploymentRoleProgress key={id} style={style} />;
    case "Opportunity Table": {
      const defaultColumns = [
        { header: "ID", field: "id" },
        { header: "Status", field: "status", type: "status" },
        { header: "Draft Name", field: "draftName" },
        { header: "Description", field: "description" },
        { header: "# Rows", field: "rows" },
        { header: "POP Start", field: "popStart" },
        { header: "POP End", field: "popEnd" },
      ];
      const defaultRows = [
        {
          id: "O-012345",
          status: "Open",
          draftName: "Government Project Proposal",
          description: "The initiative focuses on upgrading...",
          rows: 1,
          popStart: "Jan 1, 2024",
          popEnd: "Aug 1, 2024",
          subRows: [
            {
              bidRow: 1,
              status: "Active",
              role: "PW10 | Proposal Writer",
              associate: "Alice Johnson",
              hourlyRate: 150,
              popStart: "Jan 1, 2026",
              popEnd: "Aug 1, 2026",
            },
            {
              bidRow: 2,
              status: "Inactive",
              role: "GR08 | Graphic Artist",
              associate: "Sophia Brown",
              hourlyRate: 250,
              popStart: "Jan 1, 2026",
              popEnd: "Aug 1, 2026",
            },
          ],
        },
      ];
      const columns = node.columns || defaultColumns;
      const rows = node.rows || defaultRows;
      return (
        <OppTable
          key={id}
          columns={columns}
          rows={rows}
          sx={sxProp}
          {...restProps}
        />
      );
    }

    // Custom components can be added here with their own specific rendering logic
    case "Expanded Radio Button":
      return <ExpandedRadioButton key={id} node={node} />;
    case "File Upload":
      return <FileUpload key={id} {...restProps} node={node} />;
    case "File Uploaded":
      return <FileUploaded key={id} node={node} />;
    case "Loader":
      return <Loader key={id} label={node?.Text?.label || "Loading..."} />;

    case "General Card":
      return <CardTamplate key={id} node={node} />;
    case "Employment History Card":
      return <EmploymentHistoryCard key={id} node={node} />;
    case "Deployment Role Category Card":
      return <DeploymentRoleCategoryCard key={id} node={node} />;
    case "Past Project Card":
      return <PastProjectCard key={id} node={node} {...restProps} />;
    case "Alert":
      return <Alert variant="info" key={id} node={node} {...restProps} />;
    default:
      return;
  }
};

export default function PageConverter({
  jsonData,
  state = {},
  handlers = {},
  customProps = {},
  dataJson,
}) {
  // If dataJson is provided, use its fields for binding
  const bindingFields = dataJson?.fields || {};
  const [showFloating, setShowFloating] = useState(false);
  const [floatingData, setFloatingData] = React.useState(null);
  
  const handleShowFloating = (event, data) => {
    setFloatingData({ event, data });
    setShowFloating(true);
  };
  const mergedProps = {
    ...customProps,
    state,
    handlers,
    bindingFields,
    handleShowFloating,
  };

  return (
    <Box
      sx={{
        ...jsonData?.page?.layout,
      
      }}
    >
      {jsonData?.structure?.map((node) => renderNode(node, mergedProps))}
      {showFloating && floatingData && (
        <FloatingItem
          jsonData={floatingData.data}
          event={floatingData.event}
          customProps={customProps}
          open={showFloating}
          onClose={() => setShowFloating(false)}
        />
      )}
    </Box>
  );
}
